import { gql } from '@provision/graphql-client';

export const CONVERSATION_MESSAGE_DRAFT_FRAGMENT = gql`
  fragment ConversationMessageDraftFields on ConversationMessageDraft {
    id
    conversationMessageDraftId
    partnerId
    userId
    isPrivate
    message
    messageHtml
    conversationId
    scheduledAt
    sideEffects
    sendUnless
    discardedAt
    attachments {
      id
      conversationAttachmentId
      conversationId
      partnerId
      fileKey
      fileName
      contentType
      size
    }
    conversation {
      id
      conversationId
      subject
      workspaceConversationId
      conversationStatusId
    }
    createdAt
    updatedAt
  }
`;
